import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const useRestoreContrato = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { setAttTable } = useConfigPageContext();

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState<string | number>("");

  const handleRestore = async () => {
    if (!id)
      return handleGetAlert({ message: "Escolha uma linha para restaurar" });

    setLoading(true);

    return api
      .patch(`/contratos/${id}/restore`)
      .then((res) => {
        setOpen(false);
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setId("");
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    handleRestore,
    loading,
    setOpen,
    setId,
    open,
  };
};
